import { scan } from '@purpurds/purpur/icon/assets/scan';
import { warning } from '@purpurds/purpur/icon/assets/warning';
import { error } from '@purpurds/purpur/icon/assets/error';
import { logout } from '@purpurds/purpur/icon/assets/logout';
import { arrowLeft } from '@purpurds/purpur/icon/assets/arrow-left';
import { arrowRight } from '@purpurds/purpur/icon/assets/arrow-right';
import { box } from '@purpurds/purpur/icon/assets/box';
import { summary } from '@purpurds/purpur/icon/assets/summary';
import { home } from '@purpurds/purpur/icon/assets/home';
import { endUser } from '@purpurds/purpur/icon/assets/end-user';
import { phone } from '@purpurds/purpur/icon/assets/phone';
import { pulse } from '@purpurds/purpur/icon/assets/pulse';
import { map } from '@purpurds/purpur/icon/assets/map';
import { chevronDown } from '@purpurds/purpur/icon/assets/chevron-down';
import { chevronRight } from '@purpurds/purpur/icon/assets/chevron-right';
import { chevronLeft } from '@purpurds/purpur/icon/assets/chevron-left';
import { search } from '@purpurds/purpur/icon/assets/search';
import { checkmark } from '@purpurds/purpur/icon/assets/checkmark';
import { maximize } from '@purpurds/purpur/icon/assets/maximize';
import { close } from '@purpurds/purpur/icon/assets/close';
import { repair } from '@purpurds/purpur/icon/assets/repair';
import { delivery } from '@purpurds/purpur/icon/assets/delivery';
import { doc } from '@purpurds/purpur/icon/assets/doc';
import { documentDoc } from '@purpurds/purpur/icon/assets/document-doc';
import { documentExcel } from '@purpurds/purpur/icon/assets/document-excel';
import { documentPdf } from '@purpurds/purpur/icon/assets/document-pdf';
import { documentPpt } from '@purpurds/purpur/icon/assets/document-ppt';
import { remove } from '@purpurds/purpur/icon/assets/remove';
import { link } from '@purpurds/purpur/icon/assets/link';
import { sync } from '@purpurds/purpur/icon/assets/sync';
import { plus } from '@purpurds/purpur/icon/assets/plus';
import { arrowDown } from '@purpurds/purpur/icon/assets/arrow-down';
import { checkCircleFilled } from '@purpurds/purpur/icon/assets/check-circle-filled';
import { alertFilled } from '@purpurds/purpur/icon/assets/alert-filled';
import { info } from '@purpurds/purpur/icon/assets/info';
export const icons = {
    scan,
    warning,
    error,
    logout,
    arrowLeft,
    arrowRight,
    box,
    summary,
    home,
    endUser,
    phone,
    pulse,
    map,
    chevronDown,
    chevronRight,
    chevronLeft,
    search,
    checkmark,
    maximize,
    close,
    repair,
    delivery,
    remove,
    doc,
    documentDoc,
    documentExcel,
    documentPdf,
    documentPpt,
    link,
    sync,
    plus,
    arrowDown,
    checkCircleFilled,
    alertFilled,
    info,
};
